import { createContext } from "react";
import type { ChatControllerValue } from "@/components/chat-widget/chat-controller-types";

export const ChatControllerContext = createContext<ChatControllerValue | null>(null);
